import api from '@/api/api'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async getCalendar({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api
          .get('/cms/cleaning/get_calendar_cms', {
            params: obj
          })
          .then(response => {
            if (response.data.ok) {
              resolve(response.data.data)
            } else {
              dispatch('alerts/add', { text: response.data.message, color: 'error' }, { root: true })
              reject(response.data)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async getCleanerScheduleDay({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api
          .get('/cms/cleaning/get_schedule_cleaner_day', {
            params: obj
          })
          .then(response => {
            if (response.data.ok) {
              resolve(response.data.data)
            } else {
              dispatch('alerts/add', { text: response.data.message, color: 'error' }, { root: true })
              reject(response.data)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async getSchedule({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        api
          .get('/cms/cleaning/get_schedule_cms', {
            params: obj
          })
          .then(response => {
            if (response.data.ok) {
              resolve(response.data.data)
            } else {
              dispatch('alerts/add', { text: response.data.message, color: 'error' }, { root: true })
              reject(response.data)
            }
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    async saveState({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.set('id', obj.id)
        formData.set('state', obj.state)
        formData.set('motivo', obj.motivo)
        formData.set('sheets_cleaned', obj.sheets_cleaned)
        formData.set('towels_cleaned', obj.towels_cleaned)
        api
          .post('/cms/cleaning/update_state_schedule', formData)
          .then(response => {
            if (response.data.ok) {
              resolve(response.data.data)
            } else {
              dispatch('alerts/add', { text: response.data.message_detail, color: 'error' }, { root: true })
              reject(response.data)
            }
          })
          .catch(e => {
            dispatch('alerts/add', { text: e, color: 'error' }, { root: true })
            reject(e)
          })
      })
    },
    async updateCalendar({ dispatch }, obj) {
      return new Promise((resolve, reject) => {
        const formData = new FormData()
        formData.set('calendar', JSON.stringify(obj.calendar))
        formData.set('promotion_code', obj.promotion_code)
        formData.set('cleaners', JSON.stringify(obj.cleaners))
        api
          .post('/cms/cleaning/update_calendar', formData)
          .then(response => {
            if (response.data.ok) {
              resolve(response.data.data)
            } else {
              dispatch('alerts/add', { text: response.data.message_detail, color: 'error' }, { root: true })
              reject(response.data)
            }
          })
          .catch(e => {
            dispatch('alerts/add', { text: e, color: 'error' }, { root: true })
            reject(e)
          })
      })
    }
  },
  getters: {}
}
